import type { MeasureQuery } from "@adea/product/watch/actions/specs";
import { createFileRoute } from "@tanstack/react-router";
import { MeasureScreen, type MeasureSearch } from "../../screens/measures/MeasureScreen.tsx";

/** The view rides in the link (period, grain, filter, split), so a link opens the same view. */
const parseSearch = (s: Record<string, unknown>): MeasureSearch => {
  const day = (v: unknown) => (typeof v === "string" && /^\d{4}-\d{2}-\d{2}$/.test(v) ? v : undefined);
  const grain = ["day", "week", "month", "quarter", "year"].includes(String(s.grain))
    ? (s.grain as MeasureQuery["grain"])
    : undefined;
  return {
    ...(day(s.from) ? { from: day(s.from) } : {}),
    ...(day(s.to) ? { to: day(s.to) } : {}),
    ...(grain ? { grain } : {}),
    ...(typeof s.split === "string" && s.split ? { split: s.split } : {}),
    ...(typeof s.filter === "string" && s.filter ? { filter: s.filter } : {}),
  };
};

/** `/measures/$recipeId`: a tracked measure's page. */
export const Route = createFileRoute("/_app/measures/$recipeId")({
  validateSearch: parseSearch,
  component: MeasureScreen,
});
